import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useEffect, useState } from "react";
import { IGetTreeSubcodes, ITreeSubCodeReq } from "../../../../models/treeCodes.model";
import useAxios from "../../../../hooks/useAxios";
import { IExpenseList, IExpenseListParams, IGetExpenseList, IGetTotalAmount } from "../../../../models/financials.model";
import { DateTableType, ExpensePageType } from "../../../../constans";
import { getSubcodes } from "../../../../api/treeCodes.api";
import moment from "moment";
import config from "../../../../lib/config";
import { getCommonCodeLabel } from "../../../../lib/store";
import { DatePicker, Select, Table, TableColumnsType } from "antd";
import Loader from "../../../Loader";
import SelectCampusMultiChoice from "../../../SelectCampusMultiChoice";
import SelectCampus from "../../../SelectCampus";
import FinancialDatePicker from "../FinancialDatePicker";
import Button from "../../../Button";
import Split from "react-split";
import DownloadButton from "../../../DownloadButton";
import DownloadPDFButton from "../../../DownloadPDFButton";
import Pagination from "../../../Pagination";
import { getExpenses, getExpenseTotalAmount } from "../../../../api/financials.api";
import ExpenseCreate from "./Create";
import exportTable from "../../../../lib/exportTable";
import ExpenseRead from "./Read";
import ExpenseEdit from "./Edit";
import ExpenseCopy from "./Copy";
import MakePDFModal from "../modals/MakePDFModal";
import useNotification from "../../../../hooks/useNotification";
import ExpenseEditAmount from "./EditAmount";
import styled from "styled-components";

const Block = styled.div`
    .expense-title {
        width: 190px;
    }
    .expense-title div {
        width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: no-wrap;
    }
    .expense-account div {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: no-wrap;
    }
`;

const ExpenseList = () => {

    const maxPageSize = 9999999;
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { infoNotification } = useNotification();

    const [campusCodes, setCampusCodes] = useState<string[]>([]);
    const [srtDate, setSrtDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [defSelType, setDefSelType] = useState<number>(0);
    const commonCode = "FA0001";  //지출 트리공통코드
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // FA0001 = 조건
    const FA0001 = commonCodes.find(item => item.commonCode === 'FA0001')?.detailCode;
    // FA0002 = 지출 방법
    const FA0002 = commonCodes.find(item => item.commonCode === 'FA0002')?.detailCode;
    // FA0003 = 지출 여부
    const FA0003 = commonCodes.find(item => item.commonCode === 'FA0003')?.detailCode;
    // FA0005 = 결재 상태
    const FA0005 = commonCodes.find(item => item.commonCode === 'FA0005')?.detailCode;
    // FA0006 = 결재의견 등록 여부
    const FA0006 = commonCodes.find(item => item.commonCode === 'FA0006')?.detailCode;

    const [searchType, setSearchType] = useState("");
    const [approvalStatus, setApprovalStatus] = useState("");
    const [expenseMtd, setExpenseMtd] = useState("");
    const [expenseYn, setExpenseYn] = useState("");
    const [commentYn, setCommentYn] = useState("");
    const [account1, setAccount1] = useState("");
    const [account2, setAccount2] = useState("");
    const [account3, setAccount3] = useState("");
    const [clientName, setClientName] = useState("");
    const [title, setTitle] = useState("");
    
    const {data: expenseList, isLoading: isLoading1, error: error1, execute: executeList } = useAxios<IGetExpenseList>();
    const {data: expenseTotalAmt, isLoading: isLoading2, error: error2, execute: executeTotalAmt } = useAxios<IGetTotalAmount>();
    const {data: account1Data, isLoading: isLoadinga1, error: errora1, execute } = useAxios<IGetTreeSubcodes>();
    const {data: account2Data, isLoading: isLoadinga2, error: errora2, execute: execute2 } = useAxios<IGetTreeSubcodes>();
    const {data: account3Data, isLoading: isLoadinga3, error: errora3, execute: execute3 } = useAxios<IGetTreeSubcodes>();
    const [account2Res, setAccount2Res] = useState<IGetTreeSubcodes>();
    const [account3Res, setAccount3Res] = useState<IGetTreeSubcodes>();
    const [page, setPage] = useState(1);
    const [expenseRefineList, setExpenseRefineList] = useState<IExpenseList[]>([]);
    const [pageType, setPageType] = useState(ExpensePageType.CREATE); 
    const [expenseAmount, setExpenseAmount] = useState('0');
    const [exportTableLoading, setExportTableLoading] = useState(false);
    const [selectedExpenseCode, setSelectedExpenseCode] = useState<any>();
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectsKeys, setSelectsKeys] = useState<React.Key[]>([]);
    const [copyExpenseCode, setCopyExpenseCode] = useState<number>();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [visiblePdfDownload, setVisiblePdfDownload] = useState(false);

    useEffect(() => {
        getAccountCodes(1, 0);

        const defaultDate = moment(new Date());  //작성일
        setSrtDate(moment(defaultDate).format('YYYYMM01'));
        setEndDate(moment(defaultDate).format('YYYYMMDD'));
    },[]);

    useEffect(() => {
        if(account2Data) {
            setAccount2Res({...account2Data});
        }
    },[account2Data])

    useEffect(() => {
        if(account3Data) {
            setAccount3Res({...account3Data});
        }
    },[account3Data])

    useEffect(() => {
        if (FA0001) {
            setSearchType(FA0001[0].detailCode);
        }
    }, [FA0001]);

    /*  페이징 maxPageSize 미사용 시 해제
    useEffect(() => {
        if(isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        getExpenseList('P');
    }, [page]);
    */

    useEffect(() => {
        if(expenseTotalAmt?.data) {
            setExpenseAmount(expenseTotalAmt.data.totalAmount.toLocaleString());
        }
    }, [expenseTotalAmt]);

    useEffect(() => {
        if(expenseList) {
            let tempExpenseList : IExpenseList[]  = _.cloneDeep(expenseList.data);

            if (tempExpenseList.length > 0) {
                let tempNo = 1;
                tempExpenseList.forEach((item: IExpenseList) => {
                    item.no = (config.pageSize * (page-1)) + tempNo;
                    tempNo++;
                    item.expenseDate = moment(item.expenseDate).format("YYYY-MM-DD");
                    item.expenseMtd = getCommonCodeLabel('FA0002', item.expenseMtd, i18n.language); 
                    item.expenseYn = getCommonCodeLabel('FA0003', item.expenseYn, i18n.language); 
                    item.memberName = item.memberName + ((item.memberEngName) ? '(' + item.memberEngName + ')' : "");
                    item.clientBankCode = getCommonCodeLabel('SY0007', item.clientBankCode, i18n.language);
                    item.approvalStatus = getCommonCodeLabel('FA0005', item.approvalStatus, i18n.language);
                    item.commentYn = item.commentCount > 0 ? 'Y' : 'N';
                });
            }
            setExpenseRefineList(tempExpenseList);
            initSelects();
        }    
    }, [expenseList]);

    const renderContent = () => {
        switch (pageType) {
            case ExpensePageType.CREATE:
                return <ExpenseCreate 
                    getExpenseList={getExpenseList} 
                    setSelectedRow={setSelectedExpenseCode} 
                    setPageType={setPageType} 
                />;
            case ExpensePageType.UPDATE:
                return <ExpenseEdit
                    expenseCode={selectedExpenseCode} 
                    commonCode={commonCode} 
                    getExpenseList={getExpenseList} 
                    setPageType={setPageType}  
                />;
            case ExpensePageType.AMOUNT_UPDATE:
                return <ExpenseEditAmount
                    expenseCode={selectedExpenseCode} 
                    commonCode={commonCode} 
                    getExpenseList={getExpenseList} 
                    setPageType={setPageType}  
                />;
            case ExpensePageType.COPY:
                return <ExpenseCopy
                    getExpenseList={getExpenseList} 
                    commonCode={commonCode} 
                    setSelectedRow={setSelectedExpenseCode} 
                    setPageType={setPageType} 
                    expenseCode={copyExpenseCode} 
                />;
            case ExpensePageType.VIEW:
                return <ExpenseRead 
                    expenseCode={selectedExpenseCode} 
                    commonCode={commonCode} 
                    setPageType={setPageType} 
                    getExpenseList={getExpenseList} 
                />;
            default:
                return <ExpenseCreate 
                    getExpenseList={getExpenseList} 
                    setSelectedRow={setSelectedExpenseCode} 
                    setPageType={setPageType} 
                />;
        }
        
    }

    const getAccountCodes = (treeLevel: number, parentDetailCode: number) => {
        const param: ITreeSubCodeReq = {
            commonCode: commonCode,
            parentDetailCode: parentDetailCode,
            treeLevel: treeLevel,
            useYn: 'Y'
        }

        if(treeLevel === 1) {   //계정1
            execute(getSubcodes(commonCode, param));
        } else if(treeLevel === 2) {
            execute2(getSubcodes(commonCode, param));
        } else if(treeLevel === 3) {
            execute3(getSubcodes(commonCode, param));
        }
    }

    const getExpenseList = (listType: 'A' | 'P') => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);
        
        const expenseListParam: IExpenseListParams = {
            campusCodes: campusCode,
            searchType: searchType,
            firstExpenseAccCode: account1,
            secondExpenseAccCode: account2,
            thirdExpenseAccCode: account3,
            approvalStatus: approvalStatus,
            expenseMtd: expenseMtd,
            expenseYn: expenseYn,
            expenseSrtDate: srtDate,
            expenseEndDate: endDate,
            title: title,
            treeCommonCode: commonCode,
            commentYn: commentYn,
            pageNo: 1,
            perPage: maxPageSize
        }

        executeList(getExpenses(expenseListParam));
        if(listType === 'A') {
            executeTotalAmt(getExpenseTotalAmount(expenseListParam));
        }

        setPage(1);
    }

    const expenseRowClick = (record : any) => {
        setSelectedRow(record);
        setSelectedExpenseCode(record?.expenseCode);
            
        setPageType(ExpensePageType.VIEW);
    }

    const initSelects = () => {
        setSelectsKeys([]);
    }

    const rowSelection = {
        selectedRowKeys: selectsKeys,
        onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
          setSelectsKeys(selectedRowKeys);
        }
    };

    const onCopy = () => {
        if(selectsKeys.length === 1) {
            setCopyExpenseCode(Number(selectsKeys[0]));
            setPageType(ExpensePageType.COPY)
        }
    }

    const columns: TableColumnsType<IExpenseList> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
            width: '50px',
            sorter: (a, b) => a.no - b.no
        },
        {
          title: t('common.menu.campus'),
          dataIndex: 'campusName',
          key: 'campusName',
          align: 'center',
          width: '90px',
          render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName),
          sorter: (a, b) => a.campusCode.localeCompare(b.campusCode)
        },
        {
          title: t('payment.expense.column1'),
          dataIndex: 'expenseDate',
          key: 'expenseDate',
          align: 'center',
          width: '100px',
          render: (value) => (moment(value).format('YYYY-MM-DD')),
          sorter: (a, b) => a.expenseDate.localeCompare(b.expenseDate)
        },
        {
            title: t('common.column.title'),
            dataIndex: 'title',
            key: 'title',
            align: 'center',
            className: 'expense-title',
            sorter: (a, b) => a.title.localeCompare(b.title),
            render: value => (<div className='text-left'>{value}</div>)
        },
        {
            title: t('statistics.articles.2'),
            dataIndex: 'registDate',
            key: 'registDate',
            align: 'center',
            width: '100px',
            render: (value) => (moment(value).format('YYYY-MM-DD')),
            sorter: (a, b) => a.registDate.localeCompare(b.registDate)
        },
        {
            title: t('payment.expense.column2'),
            dataIndex: 'commentYn',
            key: 'commentYn',
            align: 'center',
            width: '90px',
            render: (value) => (value === 'Y')?(
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" >
                    <path
                        d="M16.77 4H3.23A1.23 1.23 0 0 0 2 5.23v10.462a1.23 1.23 0 0 0 1.23 1.231h13.54a1.23 1.23 0 0 0 1.23-1.23V5.23A1.23 1.23 0 0 0 16.77 4z"
                        stroke="#5DBECD" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path
                        d="m2 5.54 7.212 4.336c.222.13.5.2.788.2.288 0 .566-.07.788-.2L18 5.54"
                        stroke="#5DBECD" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            ):'',
            sorter: (a, b) => a.commentYn.localeCompare(b.commentYn)
        },
        {
            title: t('entrance.schedule.column29'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + value.toLocaleString()}</div>),
            sorter: (a, b) => a.amount - b.amount
        },
        {
            title: t('common.column.writer'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
            sorter: (a, b) => a.memberName.localeCompare(b.memberName)
        },
        {
            title: t('payment.income.tab2'),
            dataIndex: 'expenseYn',
            key: 'expenseYn',
            align: 'center',
            width: '70px',
            render: value => (value),
            sorter: (a, b) => a.expenseYn.localeCompare(b.expenseYn)
        },
        {
            title: t('payment.expense.column3'),
            dataIndex: 'approvalStatus',
            key: 'approvalStatus',
            align: 'center',
            width: '70px',
            render: (value) => (value),
            sorter: (a, b) => a.approvalStatus.localeCompare(b.approvalStatus)
        },
        {
            title: t('payment.expense.column4'),
            dataIndex: 'expenseMtd',
            key: 'expenseMtd',
            align: 'center',
            width: '90px',
            render: (value) => (value),
            sorter: (a, b) => a.expenseMtd.localeCompare(b.expenseMtd)
        },
        {
            title: t('payment.income.search2') + '1',
            dataIndex: 'firstExpenseAccName',
            key: 'firstExpenseAccName',
            align: 'center',
            render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{i18n.language === 'ko' ? value : record.firstExpenseAccEngName}</div>),
            sorter: (a, b) => a.firstExpenseAccName.localeCompare(b.firstExpenseAccName)
        },
        {
            title: t('payment.income.search2') + '2',
            dataIndex: 'secondExpenseAccName',
            key: 'secondExpenseAccName',
            align: 'center',
            className: 'expense-account',
            render: (value, record) => (<div className='text-left'>{i18n.language === 'ko' ? value : record.secondExpenseAccEngName}</div>),
            sorter: (a, b) => a.secondExpenseAccName.localeCompare(b.secondExpenseAccName)
        },
        {
            title: t('payment.income.search2') + '3',
            dataIndex: 'thirdExpenseAccName',
            key: 'thirdExpenseAccName',
            align: 'center',
            className: 'expense-account',
            render: (value, record) => (<div className='text-left'>{i18n.language === 'ko' ? value : record.thirdExpenseAccEngName}</div>),
            sorter: (a, b) => a.thirdExpenseAccName.localeCompare(b.thirdExpenseAccName)
        },        
        {
            title: t('payment.expense.column5') + '(' + t('campus.shuttle.column12') + ')',
            dataIndex: 'clientBankCode',
            key: 'clientBankCode',
            align: 'center',
            width: '110px',
            render: (value) => (value),
            sorter: (a, b) => a.clientBankCode.localeCompare(b.clientBankCode)
        },
        {
            title: t('payment.expense.column6'),
            dataIndex: 'clientDepositor',
            key: 'clientDepositor',
            align: 'center',
            render: (value) => (value),
            sorter: (a, b) => a.clientDepositor.localeCompare(b.clientDepositor)
        },
        {
            title: t('payment.expense.column7'),
            dataIndex: 'clientAccNo',
            key: 'clientAccNo',
            align: 'center',
            render: (value) => (value),
            sorter: (a, b) => a.clientAccNo.localeCompare(b.clientAccNo)
        },
        {
            title: t('payment.income.column5'),
            dataIndex: 'completeYn',
            key: 'completeYn',
            align: 'center',
            width: '70px',
            render: (value) => (value==="Y"?(
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 9.938 9.647 15 16 6" stroke="#5DBECD" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ):""),
            sorter: (a, b) => a.completeYn.localeCompare(b.completeYn)
        },
    ];

    const onExportTable = () => {
        setExportTableLoading(true);
        const currentDate = moment(new Date());
        
        if(selectsKeys.length > 1) {
            const excelDownloadList = expenseRefineList.filter((item)=>{
                const result = selectsKeys.find((value)=>value === item.expenseCode);
                if(result) {
                    return true;
                } else {
                    return false;
                }
            });
            
            exportTable(columns, excelDownloadList, `${t('payment.income.tab2')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.income.tab2')}`, [5,20,15,30,15,10,20,20,10,15,15,15,15,15,15,15,20,10] );
        } else {
            exportTable(columns, expenseRefineList, `${t('payment.income.tab2')}_(${currentDate.format('YYYYMMDD')})`, `${t('payment.income.tab2')}`, [5,20,15,30,15,10,20,20,10,15,15,15,15,15,15,15,20,10] );
        }
        
        setExportTableLoading(false);
    }

    const onExportPdf = () => {
        if(selectsKeys.length === 0) {
            return infoNotification(t('payment.expense.msg11'));
        } else {
            setVisiblePdfDownload(true);
        }
    }

    return (
        <>
            {exportTableLoading ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            {
                                auth && (auth.hqYn === 'Y')
                                ? (
                                <>
                                    <SelectCampusMultiChoice
                                    placeholder={t('statistics.eLearning.title2')}
                                    onChange={setCampusCodes}
                                    value={campusCodes}
                                    />
                                    <label>
                                    ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
                                    </label>
                                </>
                                )
                                : <SelectCampus />
                            }
                        </li>
                        <li>
                            <label>{t('payment.income.search1')}</label> {/* 조건 */}
                            <Select
                                value={searchType}
                                onChange={(value)=>{setSearchType(value)}}
                            >
                                {
                                    FA0001?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '1'}</label> {/* 계정1 */}
                            <Select                                
                                value={account1}
                                onChange={(value)=>{
                                    setAccount1(value);
                                    getAccountCodes(2,Number(value));
                                    setAccount2("");
                                    setAccount3("");
                                    setAccount2Res(undefined);
                                    setAccount3Res(undefined);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account1Data?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                className="expenseAccount1"
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '2'}</label> {/* 계정2 */}
                            <Select
                                value={account2}
                                onChange={(value)=>{
                                    setAccount2(value);
                                    setAccount3("");
                                    getAccountCodes(3,Number(value));
                                    setAccount3Res(undefined);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account2Res?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                className="expenseAccount2"
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.search2') + '3'}</label> {/* 계정3 */}
                            <Select
                                value={account3}
                                onChange={(value)=>{
                                    setAccount3(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    account3Res?.data?.map((item) => {
                                        return(
                                            <Select.Option
                                                className="expenseAccount3"
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                          </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.expense.column3')}</label> {/* 결재 */}
                            <Select
                                value={approvalStatus}
                                onChange={(value)=>{
                                    setApprovalStatus(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FA0005?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.expense.column4')}</label> {/* 지출방법 */}
                            <Select
                                value={expenseMtd}
                                onChange={(value)=>{
                                    setExpenseMtd(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FA0002?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.income.tab2')}</label> {/* 지출여부 */}
                            <Select
                                value={expenseYn}
                                onChange={(value)=>{
                                    setExpenseYn(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FA0003?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li>
                            <label>{t('payment.expense.column2')}</label> {/* 결재의견 */}
                            <Select
                                value={commentYn}
                                onChange={(value)=>{
                                    setCommentYn(value);
                                }}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    FA0006?.map((item)=>{
                                        return(
                                            <Select.Option
                                                key={item.detailCode}
                                                value={item.detailCode}
                                            >
                                                {i18n.language === 'ko' ? item.korName : item.engName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </li>
                        <li className="period">
                            <label>{t('sms.list.column1')}</label> {/* 기간 */}
                            <div className="comm-btn__area">
                                <FinancialDatePicker
                                    setStartDate={setSrtDate}
                                    setEndDate={setEndDate}
                                    type={DateTableType.Simple}
                                    defSelType={defSelType}
                                    setDefSelType={setDefSelType}
                                />
                            </div>
                            <div className="date-picker__area">
                                <DatePicker
                                value={srtDate ? moment(srtDate) : undefined}
                                onChange={e => {
                                    if (e === null) setSrtDate('');
                                    else setSrtDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            ~
                            <div className="date-picker__area">
                                <DatePicker
                                value={endDate ? moment(endDate) : undefined}
                                onChange={e => {
                                    if (e === null) setEndDate('');
                                    else setEndDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            
                        </li>
                        <li>
                            <label>{t('payment.expense.column5')}</label> {/* 거래처 */}
                            <input
                                type="text"
                                className="form-control w-150p mr-1"
                                value={clientName}
                                onChange={(e)=>{ setClientName(e.target.value)}}/*(e) => setKeyword(e.target.value)*/
                            />
                        </li>
                        <li>
                            <label>{t('common.column.title')}</label> {/* 제목 */}
                            <input
                                type="text"
                                className="form-control w-150p mr-1"
                                value={title}
                                onChange={(e)=>{ setTitle(e.target.value)}}/*(e) => setKeyword(e.target.value)*/
                            />
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getExpenseList('A')}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <Split 
                className='splite-divide'
                sizes={[65, 35]}
                minSize={100}
                expandToMin={false}
                gutterSize={10}
                gutterAlign="center"
                snapOffset={30}
                dragInterval={1}
                direction="horizontal"
                cursor="col-resize"
            >
                <div className='col-frame left_panel wrap-financial wrap-expense'>
                    <div className="inner">
                        <div className="comm-bx__between">  
                            <div className="comm-sch_result">
                                {t('payment.expense.label1') + ' : '}<b>{expenseAmount}</b>{' ' + t('class.class.text6')}
                            </div>
                        </div>
                        <Block className="comm-table__area ml-th">
                            <Table
                                columns={columns}
                                dataSource={expenseRefineList}
                                pagination={{
                                    current: page,
                                    pageSize: config.pageSize,
                                }}
                                rowKey={'expenseCode'}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}
                                onRow={(record) => {
                                    return {
                                    onClick: () => {
                                        expenseRowClick(record);
                                    },
                                    };
                                }}
                                rowClassName={(record: any) =>
                                    record.expenseCode === selectedRow?.expenseCode
                                        ? 'chosen'
                                        : 'pointer'
                                }
                            />
                        </Block>
                        <div className="comm-bx__between">
                            <div className="comm-btn__area">
                                <DownloadButton onClick={onExportTable} />
                                <DownloadPDFButton onClick={onExportPdf} btnText={t('payment.expense.btn7')} />
                                <Button
                                    onClick={onCopy}
                                    className="btn-basic pink-line"
                                    text={t('campus.shuttle.button3')}
                                    disabled={((selectsKeys.length === 1)?false:true )}
                                    /*writeAuthYn={writeAuthYn}*/
                                />
                                <Button
                                    onClick={() => {
                                        setPageType(ExpensePageType.CREATE)
                                    }}
                                    className="btn-basic pink"
                                    text={t('common.button.create')}
                                    /*writeAuthYn={writeAuthYn}*/
                                />
                            </div>
                            <div className="common-paging center">
                                <Pagination
                                    count={expenseList?.total || 0}
                                    page={page}
                                    setPage={setPage}
                                    perPage={config.pageSize}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='finan_right_panel'>
                    {renderContent()}
                </div>
            </Split>
            <MakePDFModal
                visible={visiblePdfDownload}
                setVisible={setVisiblePdfDownload}
                selectedExpenseCodes={selectsKeys}
                commonCode={commonCode}
            />
        </>
    )
}

export default ExpenseList;